<template>
  <div class="home__contact" id="contact">
    <div class="home__contact__form">
      <div class="home__contact__form__open">
        <h3>Godziny otwarcia:</h3>
        <ul>
          <li>Pn. - Pt.: 13:00 - 23:00</li>
          <li>Weekend: 12:00 - 23:00</li>
        </ul>
      </div>
      <div class="home__contact__form__contact">
        <h3>Zachęcamy do kontaktu:</h3>
        <ul>
          <li>Numer tel: <a href="tel:+48533328281">533 328 281</a></li>
          <li>E-mail: <a target="_blank" href="mailto:jadalnia@patriotow303.pl">jadalnia@patriotow303.pl</a></li>
          <li>Adres: Patriotów 303 Wawer, Warszawa</li>
        </ul>
      </div>
    </div>
    <div class="home__contact__map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2982.25437110081!2d21.167868512560176!3d52.203123685681646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x471ed301440fe311%3A0x2f621c8ae821b3b!2sJadalnia+Lokalna+Restauracja+w+Mi%C4%99dzylesiu!5e1!3m2!1spl!2spl!4v1554834514555!5m2!1spl!2spl"
        frameborder="0" style="border:0" allowfullscreen></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Contact'
}
</script>
